import React from 'react';
import { Editor, EditorTools } from '@progress/kendo-react-editor';
import ReferenceFiles from "../../../sections/Instructions/ReferenceFiles/ReferenceFiles";
import Policies from "../../../../util/Policies";
import Instructions, { propsType } from "../../Instructions/Instructions";
import { checkFilesEquality } from "../Utility"
import _ from "lodash";
import { HBox, Position, PuzzleColorPicker, VBox } from "puzzle";
import { POPUPSTATE } from "./Types";
import FontSizeTool from "puzzle/components/UI/rich_text_editor/font/font_size_tool/FontSizeTool";

const {
  Bold, Italic, Underline,
  AlignLeft, AlignCenter, AlignJustify,
  OrderedList, UnorderedList
} = EditorTools;

class InstructionsPopup extends Instructions {

  static defaultProps = {
    moduleName: 'Instructions',
    moduleId: 'PopUpInstructions',
    dispatcherUpdateStates: {
      uploadFlowState: {}
    }
  };

  public state: POPUPSTATE = {
    ...this.state,
    uploadFlowState: {}
  };

  /**
   * @inheritDoc
   */
  componentDidUpdate(prevProps: propsType, prevState: POPUPSTATE) {
    super.componentDidUpdate(prevProps, prevState);

    const { uploadFlowState: currentUploadFlowState } = this.state;
    const { uploadFlowState } = prevState;

    if (!_.isEqual(currentUploadFlowState, uploadFlowState)) {

      const fileUploadInProgress = !this.isAllUploadEnd();
      if (this.isModuleMounted) {
        this.dispatch('updateInstructionsPopupDialog', {
          pos: Position.start,
          persistent: ['uploadIsInProgress']
        }, {
          uploadIsInProgress: fileUploadInProgress
        })
      }
    }
  };

  /**
   * Puts set Editors data to end of the steak
   * @param data
   */
  delaySetData = (data: any) => {
    setTimeout(this.setData.bind(this, data), 0);
  };

  /**
   * Checks is there is any changes in received and current data
   * @param instructions
   */
  hasDataChange = (instructions: any) => {
    const { notesHtmlText, instructionsHtmlText } = instructions;
    let dataChanged = false;
    if (instructionsHtmlText !== this.state.instructionsHtmlText || notesHtmlText !== this.state.notesHtmlText) {
      dataChanged = true;
    }
    if (!checkFilesEquality(instructions.referenceFiles, this.state.referenceFiles)) {
      dataChanged = true;
    }

    return dataChanged
  };

  renderBody() {
    const { project } = this.props.form.getData();
    const { submissionStatus, submissionId } = this.props;
    const hasSubmissionReferenceFilesPolicy = Policies.inProject(project)?.hasSubmissionReferenceFilesPolicy;

    return (
      <VBox
        gap={3}
        flex1
        className='tp-instructions-and-reference-files-section'
        ref={wrapper => this.instructionsWrapperRef = wrapper}
      >
        <HBox className={'tp-instructions-section'} flex1>
          <Editor
            ref={editor => {
              this.editorRef = editor
            }}
            className={`tp-section-instructions-editor k-vbox k-flex-1 tp-no-border ${this.state.isPlaceholderVisible ? 'tp-empty' : ''}`}
            tools={[
              [Bold, Italic, Underline],
              [UnorderedList, OrderedList],
              [AlignCenter, AlignJustify, AlignLeft],
              [FontSizeTool],
              [PuzzleColorPicker],
              [this.tabStripFunctionComponent]
            ]}

            onChange={this.onInputChange}
            defaultEditMode={'div'}
          />
        </HBox>
        {hasSubmissionReferenceFilesPolicy ?
          <VBox className={'tp-reference-files-section'} gap={3}>
            <div className={'pd-ref-files-section-tile tp-text-medium'}>{this.translate('referenceFiles')}</div>
            <ReferenceFiles
              showDnDMsg
              deleteOnSave
              moduleId={'fromInstructionsPopUp'}
              onChange={this.onUploadChange}
              submissionId={submissionId}
              submissionStatus={submissionStatus}
            />
          </VBox> : null}
      </VBox>
    );
  }
}

export default InstructionsPopup;
